import { getDate } from "@poseidon/firebase/timestamp";

export const mapSailor = async (docRef) => {
  let sailor = docRef.data();
  return {
    ...sailor,
    id: docRef.id,
    dateStartedJob: getDate(sailor.dateStartedJob),
    createdAt: getDate(sailor.createdAt),
    updatedAt: getDate(sailor.updatedAt),
  };
};
